/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RingcentralConfig
 */
export interface RingcentralConfig {
    /**
     * 
     * @type {string}
     * @memberof RingcentralConfig
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof RingcentralConfig
     */
    password: string;
}

/**
 * Check if a given object implements the RingcentralConfig interface.
 */
export function instanceOfRingcentralConfig(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function RingcentralConfigFromJSON(json: any): RingcentralConfig {
    return RingcentralConfigFromJSONTyped(json, false);
}

export function RingcentralConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): RingcentralConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': json['username'],
        'password': json['password'],
    };
}

export function RingcentralConfigToJSON(value?: RingcentralConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
        'password': value.password,
    };
}

